import type {
  ICalculatorInitiatedEvent,
  ICalculatorInitiatedInput,
} from '../types/clickEvents';

const calculatorInitiated = (
  input: ICalculatorInitiatedInput,
): Omit<ICalculatorInitiatedEvent, 'event'> => ({
  linkDetails: input.linkDetails ?? { linkName: '' },
  module: input.moduleName ? { moduleName: input.moduleName } : undefined,
});

export default calculatorInitiated;
